import { Atom, atom } from 'jotai'
import { alphamapClient } from 'src/clients'
import { AMOwnershipEntityAcquisitionOverview } from 'src/common-services'
import { atomFamily } from 'src/utils/jotai'
import * as atoms from 'src/v2/state/owner-reveal'

export const entityGraph = atom(async (get) => {
  const entityId = await get(atoms.selectedEntityId)
  if (!entityId) {
    return undefined
  }

  return await alphamapClient.ownership.getEntityGraphOverview(entityId)
})

export const entitySummaryById = atomFamily<string, Atom<Promise<AMOwnershipEntityAcquisitionOverview>>>(
  (entityId: string) =>
    atom(async (get) => {
      const contacts = await get(entityGraph)
      const summary = await alphamapClient.ownership.getEntitySummary(entityId)
      summary.amountOfContacts = contacts?.relatedContacts || undefined
      return summary
    })
)
